import { Component, OnInit } from '@angular/core';
import { faAt, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  icons = {
    cancel: faTimes,
    close: faTimes,
    at: faAt
  };
  title: string;
  subtitle: string;
  data: any;
  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions

  ) {
    this.data = this.options?.initialState
  }

  ngOnInit(): void {
  }

  close() {
    this.bsModalRef?.hide()
  }

}
